"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCurrentSlide = getCurrentSlide;
exports.next = next;
exports.previous = previous;
function getCurrentSlide() {
    return this.elements.slides[this.currentSlide + this.slideOffset];
}

function next() {
    this.changeSlide(1, true);
}

function previous() {
    this.changeSlide(-1, true);
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/slider/util.js
// module id = ./resources/assets/js/src/slider/util.js
// module chunks = 0